const BrandIcon = ({ width = '15pt', height = '15pt' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 180 180"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0,180) scale(0.1,-0.1)"
      fill="#000000"
      stroke="none"
    >
      <path
        d="M0 900 l0 -900 900 0 900 0 0 900 0 900 -900 0 -900 0 0 -900z m797
      600 c45 -27 73 -88 80 -173 3 -40 10 -80 15 -89 21 -41 68 -17 198 97 97 85
      157 122 232 142 58 15 74 16 115 5 89 -24 140 -81 168 -187 11 -44 15 -108 14
      -245 l0 -185 -23 68 c-26 77 -79 140 -134 158 -54 18 -150 7 -212 -24 -30 -14
      -97 -62 -148 -106 -113 -98 -141 -118 -175 -126 -33 -9 -43 12 -52 107 -12
      123 -72 198 -160 198 -117 0 -288 -95 -443 -246 -47 -46 -87 -84 -89 -84 -2 0
      -3 81 -3 180 l0 181 108 107 c162 163 298 241 417 242 42 0 70 -6 92 -20z m-2
      -499 c42 -23 74 -93 82 -177 12 -145 29 -143 227 23 54 45 123 94 153 108 157
      75 293 19 342 -141 18 -57 21 -91 20 -258 l-1 -191 -18 58 c-41 129 -109 182
      -228 175 -92 -5 -156 -38 -278 -144 -105 -91 -163 -128 -188 -118 -19 7 -23
      21 -31 106 -8 82 -39 145 -85 176 -30 21 -44 23 -99 19 -122 -9 -325 -139
      -444 -282 -28 -35 -55 -64 -59 -64 -5 -1 -8 84 -8 187 l0 188 73 79 c93 101
      198 185 289 230 113 55 186 63 253 26z"
      />
    </g>
  </svg>
);

export default BrandIcon;
